import { render, staticRenderFns } from "./AfcodeDown.vue?vue&type=template&id=34846658&scoped=true&"
import script from "./AfcodeDown.vue?vue&type=script&lang=js&"
export * from "./AfcodeDown.vue?vue&type=script&lang=js&"
import style0 from "./AfcodeDown.vue?vue&type=style&index=0&id=34846658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34846658",
  null
  
)

export default component.exports